
import { getPlatformName } from "./getPlatformName"
import { getSvgIcons } from "./getReactIcons"

export const restructure_ads_data = (adsData) => {
  try {

    let metricsData = []
    let campaignMetricsData = []
    let graph_data = {}
    if (adsData == null) {
      return {}
    }



    if (adsData?.platform_id != null && getPlatformName(adsData?.platform_id) === "Google") {
      metricsData = [
        {
          name: 'Video Views',
          value: adsData?.metrics_data?.videoViews?.value ?? 0,
          icon: getSvgIcons('video'),
          description:adsData?.metrics_data?.videoViews?.description ?? ''

        },
        {
          name: 'Conversions',
          value: adsData?.metrics_data?.conversions?.value ?? 0,
          icon: getSvgIcons('document'),
          description:adsData?.metrics_data?.conversions?.description ?? ''


        },
        {
          name: 'Engagements',
          value: adsData?.metrics_data?.engagements?.value ?? 0,
          icon: getSvgIcons('document'),
          description:adsData?.metrics_data?.engagements?.description ?? ''


        },
        {
          name: 'Interactions',
          value: adsData?.metrics_data?.interactions?.value ?? 0,
          icon: getSvgIcons('document'),
          description:adsData?.metrics_data?.interactions?.description ?? ''


        },
        {
          name: 'Gmail Forwards',
          value: adsData?.metrics_data?.gmailForwards?.value ?? 0,
          icon: getSvgIcons('document'),
          description:adsData?.metrics_data?.gmailForwards?.description ?? ''


        },
        {
          name: 'Gmail Saves',
          value: adsData?.metrics_data?.gmailSaves?.value ?? 0,
          icon: getSvgIcons('bookmark'),
          description:adsData?.metrics_data?.gmailSaves?.description ?? ''


        }

      ]
      campaignMetricsData = [
        {
          name: 'Clicks',
          value: adsData?.external_campaign_details?.clicks,
          icon: getSvgIcons('clicks'),
          description:''


        },
        {
          name: 'Impressions',
          value: adsData?.external_campaign_details?.impressions,
          icon: getSvgIcons('document'),
          description:''


        },
        {
          name: 'Conversions',
          value: adsData?.external_campaign_details?.conversions,
          icon: getSvgIcons('document'),
          description:''


        },
        {
          name: 'CTR',
          value: adsData?.external_campaign_details?.click_through_rate,
          icon: getSvgIcons('document'),
          description:''


        },


      ]

           const sortedMetrics = adsData?.monthly_metrics?.length > 0
        ? [...adsData.monthly_metrics].sort((a, b) => new Date(a.start_date) - new Date(b.start_date))
        : [];

      graph_data = {
        labels: sortedMetrics.map((data) =>
          new Date(data?.start_date).toLocaleString('default', { month: 'short', year: 'numeric' })
        ),
        datasets: [
          {
            label: 'Clicks',
            data: sortedMetrics.map((data) => data?.clicks),
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
          },
          {
            label: 'Impressions',
            data: sortedMetrics.map((data) => data?.impressions),
            borderColor: 'rgb(53, 162, 235)',
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
          },
          {
            label: 'Spent',
            data: sortedMetrics.map((data) => data?.spent),
            borderColor: 'rgba(255, 205, 86, 0.2)',
            backgroundColor: 'rgba(255, 205, 86, 0.2)',
          },
        ],
      };



    }

    if (adsData?.platform_id != null && getPlatformName(adsData?.platform_id) === "Linkedin") {
      metricsData = [
        {
          name: 'Video Views',
          value: adsData?.metrics_data?.video_views?.value,
          icon: getSvgIcons('video'),
          description:adsData?.metrics_data?.video_views?.description


        },
        {
          name: 'Comments',
          value: adsData?.metrics_data?.comments?.value,
          icon: getSvgIcons('video'),
          description:adsData?.metrics_data?.comments?.description


        },
        {
          name: 'Shares',
          value: adsData?.metrics_data?.shares?.value,
          icon: getSvgIcons('video'),
          description:adsData?.metrics_data?.shares?.description


        },
        {
          name: 'Total Engagements',
          value: adsData?.metrics_data?.total_engagements?.value,
          icon: getSvgIcons('video'),
          description:adsData?.metrics_data?.total_engagements?.description


        },
        {
          name: 'Likes',
          value: adsData?.metrics_data?.likes?.value,
          icon: getSvgIcons('heart'),
          description:adsData?.metrics_data?.likes?.description


        },


      ]
      campaignMetricsData = [
        {
          name: 'Clicks',
          value: adsData?.external_campaign_details?.clicks,
          icon: getSvgIcons('clicks'),
          description:'Total clicks on any link within the post.'


        },
        {
          name: 'Impressions',
          value: adsData?.external_campaign_details?.impressions,
          icon: getSvgIcons('video'),
          description:'Number of times the post was shown (may include repeats to the same user).'


        },
        {
          name: 'Total Budget Amount',
          value: adsData?.external_campaign_details?.total_budget_amount,
          icon: getSvgIcons('dollar'),
          description:'Total amount spent on the ad campaign.'


        },
        {
          name: 'Reactions',
          value: adsData?.external_campaign_details?.reactions,
          icon: getSvgIcons('video'),
          description:'Count of different reaction types like Like, Love, etc.'


        },


      ]

      const sortedMetrics = adsData?.monthly_metrics?.length > 0
        ? [...adsData.monthly_metrics].sort((a, b) => new Date(a.start_date) - new Date(b.start_date))
        : [];

      graph_data = {
        labels: sortedMetrics.map((data) =>
          new Date(data?.start_date).toLocaleString('default', { month: 'short', year: 'numeric' })
        ),
        datasets: [
          {
            label: 'Clicks',
            data: sortedMetrics.map((data) => data?.clicks),
            borderColor: 'rgb(255, 99, 132)',
            backgroundColor: 'rgba(255, 99, 132, 0.5)',
          },
          {
            label: 'Impressions',
            data: sortedMetrics.map((data) => data?.impressions),
            borderColor: 'rgb(53, 162, 235)',
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
          },
          {
            label: 'Shares',
            data: sortedMetrics.map((data) => data?.metrics_data?.shares),
            borderColor: 'rgba(255, 205, 86, 0.2)',
            backgroundColor: 'rgba(255, 205, 86, 0.2)',
          },
        ],
      };





    }



    return { metricsData, campaignMetricsData, graph_data }



  }
  catch (e) {
    console.log(e)
  }

}


